import React, { useState, useRef } from "react"
import { parse, isBefore } from "date-fns"

import DayPickerInput from "react-day-picker/DayPickerInput"
import { DateUtils } from "react-day-picker"
import dateFnsFormat from "date-fns/format"
import dateFnsParse from "date-fns/parse"
import { useDispatch } from "react-redux"
import {
  updateCategoryClaimData,
  formIsValidUpdate,
} from "../../../../Redux/WindscreenClaim/actions"
import * as Constants from "../../../../common/constants"

const DateField = ({ field, form, label, startDate, ...props }) => {
  const dispatch = useDispatch()

  const FORMAT = "dd/MM/yyyy"
  const elDate = useRef(null)
  const selected = field.value
  const [, setOpen] = useState(false)
  let disableBefore
  let disableAfter

  let customClassName = ""

  if (props.inputProps.disabled) {
    customClassName += " disableBGcolor"
  }

  if (props.disableBefore) {
    if (form.values[props.disableBefore]) {
      disableBefore = form.values[props.disableBefore]
    } else {
      disableBefore = parse(props.disableBefore, `d/M/yyyy`, new Date())
    }
  }

  if (props.disableAfter) {
    if (form.values[props.disableAfter]) {
      disableAfter = form.values[props.disableAfter]
    } else {
      disableAfter = parse(
        props.disableAfter,
        `d${Constants.sep}M${Constants.sep}yyyy`,
        new Date()
      )
    }
  }

  const parseDate = (str, format, locale) => {
    const parsed = dateFnsParse(str, format, Date.now())
    if (DateUtils.isDate(parsed) && parsed.getFullYear() > 1000) {
      return parsed
    }
    return undefined
  }
  const formatDate = (date, format, locale) => {
    return dateFnsFormat(date, format)
  }
  const handleChange = val => {
    const category = props.category
    let targetCoverageCode

    if (props.specifyCoverageCode) {
      targetCoverageCode = props.specifyCoverageCode
    } else {
      targetCoverageCode = props.coverageCode
    }

    form.setFieldValue(field.name, val)
    const inputName = field.name
    const inputValue = val
    // const isValid = props.formIsValid

    //console.log(props.formIsValid)
    dispatch(
      updateCategoryClaimData(
        category,
        targetCoverageCode,
        inputName,
        inputValue
      )
    )

    // let errorsList = form.errors
    // delete errorsList[field.name]
    form.resetForm()
    form.validateForm().then(errors => {
      // console.log(errors)
      if (Object.entries(errors).length === 0) {
        // console.log("PASS")
        dispatch(formIsValidUpdate(props.formName, true))
      } else {
        // console.log("FAIl")
        dispatch(formIsValidUpdate(props.formName, false))
      }
    })

    form.resetForm()
    // form.validateForm()
  }

  const modifiers = () => {
    let limitedRespond = []
    let limitedDate = {}

    if (disableBefore && props.disableBefore !== "disable") {
      limitedDate.before = disableBefore
    }

    if (props.disableAfter !== "disable") {
      if (!disableAfter || isBefore(new Date(), disableAfter)) {
        limitedDate.after = new Date()
      } else {
        limitedDate.after = disableAfter
      }
    }

    limitedRespond.push(limitedDate)
    return limitedRespond
  }

  const getInitialMonth = () => {
    if (props.disableAfter !== "disable") {
      if (!disableAfter || isBefore(new Date(), disableAfter)) {
        return new Date()
      } else {
        return disableAfter
      }
    }
  }

  // const invalid = form.touched[field.name] && !!form.errors[field.name]
  return (
    <>
      {/* <label style={{ marginBottom: "0px" }}>{label}</label> */}
      <DayPickerInput
        classNames={{
          container: "DayPickerInput " + props.className, // The container element
          overlayWrapper: "DayPickerInput-OverlayWrapper", // The overlay's wrapper
          overlay: "DayPickerInput-Overlay", // The overlay's container
        }}
        inputProps={{
          required: true,
          readOnly: true,
          name: props.inputProps.name,
          //className: props.className,
          disabled: props.inputProps.disabled,
          className: customClassName,
        }}
        ref={elDate}
        format={FORMAT}
        autoComplete="new-password"
        value={selected}
        placeholder={`DD/MM/YYYY`}
        formatDate={formatDate}
        parseDate={parseDate}
        //name={props.inputProps.name}
        dayPickerProps={{
          disabledDays: modifiers(),
          initialMonth: getInitialMonth(),
          numberOfMonths: 1,
          onDayClick: () => elDate.current.getInput().focus(),
        }}
        onDayChange={handleChange}
        onDayPickerShow={() => setOpen(false)}
        onDayPickerHide={() => setOpen(false)}
      />
    </>
  )
}
export default DateField
